import { Component, Inject, OnInit } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { TranslateService } from '@ngx-translate/core';
import { ActionSheetController } from '@ionic/angular';
import {
    AppSettings,
    AUTH_SERVICE_IMPL,
    ColorClass,
    FlashMessageService,
    IAuthenticationService,
    IonToasterService,
    IRealtimeClientService,
    REALTIME_CLIENT_IMPL,
} from 'shared';
import { Router } from '@angular/router';
import {
    EMPLOYEE_AUTH_SERVICE_IMPL,
    IEmployeeAuthService,
} from 'pm-src/services/employee-auth/i-employee-auth.service';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
    title = 'Provider Manager';

    public userManagerHub = AppSettings.get('realtimeUrl') + '/usermanagerhub';

    constructor(
        private _swUpdate: SwUpdate,
        private _translate: TranslateService,
        private _actionSheetController: ActionSheetController,
        @Inject(REALTIME_CLIENT_IMPL)
        private _realtimeClient: IRealtimeClientService,
        private _router: Router,
        @Inject(EMPLOYEE_AUTH_SERVICE_IMPL)
        private _employeeAuthService: IEmployeeAuthService,
        private _toasterService: IonToasterService,
        private flashMessageService: FlashMessageService,
        @Inject(AUTH_SERVICE_IMPL) public _authService: IAuthenticationService
    ) {}

    ngOnInit(): void {
        // if (this._swUpdate.isEnabled) {
        //     this._swUpdate.versionUpdates.subscribe(
        //         async () => await this.showUpdateSheet()
        //     );
        // }

        this.flashMessageService.message.subscribe((msg) => {
            this._toasterService.custom(msg, this.flashMessageService.lastType(), 4000);
        });

        this._authService.applicationUser.subscribe((user) => {
            if (user) {
                this._realtimeClient.initHubConnection(
                    'usermanagerhub',
                    AppSettings.get('realtimeUrl')
                );
                this.establishUserManagerConnections();
            } else {
                this._realtimeClient.disconnect(this.userManagerHub);
            }
        });
    }

    private establishUserManagerConnections(): void {
        this._realtimeClient.connect(this.userManagerHub).then(() => {
            this._realtimeClient.on('logoutemployee', this.userManagerHub, (response) => {
                const currentEmployee =
                    this._employeeAuthService.getEmployeeFromStorage();
                if (response[0] === currentEmployee.employeeID) {
                    this._router.navigate(['/logout']);
                    this._toasterService.error(response[1]);
                }
            });
            this._realtimeClient.on(
                'userinactivated',
                this.userManagerHub,
                (response) => {
                    const currentUser = this._authService.getUserFromStorage();
                    const targetUserID = response[0];
                    if (targetUserID === currentUser.userID) {
                        this._employeeAuthService.removeCurrentEmployee();
                        this._router.navigate(['/logout']);
                    }
                }
            );
        });
    }

    private async showUpdateSheet(): Promise<void> {
        const actionSheet = await this._actionSheetController.create({
            header: this._translate.instant('common.new-app-version-released'),
            buttons: [
                {
                    text: 'OK',
                    role: 'destructive',
                    icon: 'caret-forward-circle',
                    handler: () => {
                        window.location.reload();
                    },
                },
                {
                    text: this._translate.instant('common.cancel'),
                    icon: 'close',
                    role: 'cancel',
                },
            ],
        });
        await actionSheet.present();
    }
}
